import { Roles } from 'src/common/types'
import type { RouteRecordRaw } from 'vue-router'

export const reports: RouteRecordRaw = {
  name: 'admin.reports',
  path: 'Reports',
  component: () => import('pages/Reports.vue'),
  meta: {
    roles: [
      Roles.CenterAdmin,
      Roles.OfficeStaff,
      Roles.OrgAdmin,
      Roles.SuperAdmin,
    ],
    supportedPlatforms: ['desktop', 'mobile', 'native'],
    excludeEnv: [],
  },
}
